<template>
  <div class='registration-page'>
    <!--<div class='process-indicator' v-if="this.isStep1">
        <ul class=''>
            <li v-bind:class='{selected:this.$store.state.processIndicator.step1}'>
                <i class="step1"></i><span>약관동의</span>
            </li>

            <li v-bind:class='{selected:this.$store.state.processIndicator.step2}'>
                <i class="step2"></i><span>신청서작성</span>
            </li>

            <li v-bind:class='{selected:this.$store.state.processIndicator.step4}'>
                <i class="step4"></i><span>가입신청 완료</span>
            </li>
        </ul>
    </div>-->
    <div class='registration-page-container' v-if="this.isUsedPhone">

          <div class='section'>
            <div class='section-header'>
              <h2 v-show="this.carType == 'A'">중고폰</h2>&nbsp;<h2>개통신청</h2>
            </div>
          </div>    

      <div class='section'>
        <div class='section-header'>
          <h3>단말기 정보</h3>
        </div>
        <div class='section-body'>

          <dl class='field-group'>
            <dt class='field-label'>
              모델명
            </dt>
            <dd class='field-control'>
              <div class='field-control-sub'>
                <p class='data-text'>
                 {{this.trmMdlNm}}
                </p>
              </div>  
            </dd>
          </dl> 

          <dl class='field-group'>
            <dt class='field-label'>
              일련번호
            </dt>
            <dd class='field-control'>
              <div class='field-control-sub'>
                <p class='data-text'>
                 {{this.itemSn}}
                </p>
              </div>  
            </dd>
          </dl> 
          <ul class='notice-text-list'>
            <li class='notice-text'>일련번호는 LTE동글 후면에서 확인 가능합니다.</li>
          </ul>                            
        </div>
      </div>

      <div class='section' v-show="this.carType == 'B'">
        <div class='section-header'>
          <h3>USIM 정보</h3>
        </div>
        <div class='section-body'>

          <dl class='field-group'>
            <dt class='field-label'>
              모델명
            </dt>
            <dd class='field-control'>
              <div class='field-control-sub'>
                <p class='data-text'>
                  {{this.usimSn}}
                </p>
              </div>
            </dd>
          </dl>

          <dl class='field-group'>
            <dt class='field-label'>
              일련번호
            </dt>
            <dd class='field-control'>
              <div class='field-control-sub'>
                <p class='data-text'>
                  {{this.usimMdlNm}}
                </p>
              </div>
            </dd>
          </dl>
        </div>
      </div>

      <div class='section'>
        <div class='section-header'>
          <h3>가입정보</h3>
        </div>
        <div class='section-body'>

          <dl class='field-group' v-show="this.carType == 'B'">
            <dt class='field-label'>
              개통국번
            </dt>
            <dd class='field-control'>
              <div class='field-control-sub'>
                <p class='data-text'>
                  {{this.dashCtn}}
                </p>
              </div>
            </dd>
          </dl>

          <dl class='field-group'>
            <dt class='field-label'>
              가입유형
            </dt>
            <dd class='field-control'>
              <div class='field-control-sub'>
                <p class='data-text'  v-if="this.opmkEntrKdCd==='new'">
                  신규 가입
                </p>
                <p class='data-text'  v-else-if="this.opmkEntrKdCd==='move'">
                  번호 이동
                </p>
                <p class='data-text'  v-else-if="this.opmkEntrKdCd==='chg'">
                  기기 변경
                </p>
                <p class='data-text'  v-else-if="this.opmkEntrKdCd==='renew'">
                  재가입
                </p>
                <p class='data-text'  v-else>
                  기타
                </p>
              </div>  
            </dd>
          </dl> 

          <dl class='field-group'>
            <dt class='field-label'>
              요금제
            </dt>
            <dd class='field-control'>
              <div class='field-control-sub'>
                <p class='data-text'>
                  {{this.phonePayStyle}}
                </p>
              </div>  
            </dd>
          </dl>                           
        </div>
      </div>

      <div class='step-bottom-area input-wrap'>
        <button type='submit' class='primary-button mw100 pc-float-right' @click='goToConnectedCarStep1'>
          개통신청하기
        </button>
      </div>

    </div>
    <div class='registration-page-container' v-if="this.isStep1">
      <div class='section'>
        <div class='section-header'>
          <h3>이용약관</h3>
        </div>
        <div class='section-body'>
          <ul class="notice-text-list">
            <li class='notice-text'>아래의 이용약관을 확인하시고 동의여부에 체크해 주시기 바랍니다.</li>            
          </ul>        
          <div id='checkbox-container-agreement-all' class='input-container'>
            <input @click='checkAll' type="checkbox" id="agreement-all" value="agreement-all" class='input-checkbox input-text' title='이용약관 전체동의' >
            <label for='agreement-all' class='input-label'>아래 약관 내용에 전체 동의함</label>
          </div>
          <dl class='field-group'>
            <dt class='field-label'>
              <label>이용약관 동의</label>
            </dt>       
            <dd class='field-control'>
              <ul>
                 <li class='accordion type-01' v-for='termCondition in this.reqTermConditionList' v-bind:key='termCondition.svcToaId'>
                     <div  :id="`accordion-required-${termCondition.svcToaId}`" class='accordion-title'  role='heading'>
                      <div :id="'checkbox-container-' + termCondition.svcToaId" class='input-container'>
                        <input :id="'accordion-checkbox-' + termCondition.svcToaId"
                              type='checkbox'
                              :name='termCondition.svcToaId'
                              @click='clickedAgreement'
                              class='input-checkbox input-text'
                              v-model='termConditionCheckedStatus[termCondition.svcToaId]'>
                        <label :id="`accordion-label-${termCondition.svcToaId}`" class='input-label' :for="'accordion-checkbox-' + termCondition.svcToaId" >{{termCondition.svcToaNm}}</label>
                      </div>
                      <button class='fold-button'
                      @click='showHideAccordion(termCondition.svcToaId)'
                      title='자세히보기' tabindex='0' 
                      :area-controls="'accordion-' + termCondition.svcToaId + '-detail'" 
                      :id="termCondition.svcToaId + '-show'"
                      ></button>                      
                    </div>
                    <div :id="`accordion-${termCondition.svcToaId}-detail`" class='accordion-detail' tabindex='0' :aria-labelledby="`${termCondition.svcToaId}-show`" role='region' >
                      <div  v-if='termCondition.svcToaId ==="requiredForUPlusService"'  v-html="requiredForUPlusService" />
                      <!--<p :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForPersonalInformation"' v-html="requiredHtmlCntn1" />-->

                      <!-- [ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 :  약관내용 조회된 내용 SET  2026.05.21 -->
                      <!-- 고유식별 정보 수집.이용 동의  svcToaId = requiredForConciergeDeviceOnlyOneInformation  로 수정 -->
                      <!-- <div :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForPersonalInformation"' v-html="requiredHtmlCntn1" /> -->
                      <div :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForConciergeDeviceOnlyOneInformation"' v-html="requiredHtmlCntn1" />
                      <!-- 개인정보 수집.이용 동의 추가 -->
                      <div :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForPersonalInformation"'  v-html="requiredHtmlCntn6" />
                      <!-- 민감정보 수집 및 이용 동의(안면인증 시범서비스)추가  -->
                      <div :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForSensitiveInform_mobile"'  v-html="requiredHtmlCntn7" />

                      <!-- ST 이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가-->
                      <!-- 2026.05.21
                            개인정보.개인위치정보 수집.이용 동의 (A0006:requiredForPersonalLocationInformation)   제거
                              개인정보 수집.이용 동의(A0159:requiredForPersonalInformation), 개인위치정보 수집.이용 동의 (A0182:requiredForPersonalLocInform_mobile) 분리 적용
                      <div :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForPersonalLocationInformation"'  v-html="requiredHtmlCntn2" />
                       -->
                      <!-- ED 이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가-->

                      <!-- 개인정보 국외이전 동의 추가  -->
                      <div :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForPersonalAbroadTransfer_mobile"'  v-html="requiredHtmlCntn8" />
                      <!-- [ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 :  약관내용 조회된 내용 SET  2026.05.21 -->

                      <!-- ST 개인정보수집(requiredForPersonalInformation)과 개인위치정보수집 분리를 위한 추가 -->
                      <div :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForPersonalLocInform_mobile"'  v-html="requiredHtmlCntn5" />
                      <!-- ED 개인정보수집(requiredForPersonalInformation)과 개인위치정보수집 분리를 위한 추가 -->
                      <div :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForServiceProviding"'  v-html="requiredHtmlCntn3" />
                      <div :id="`accordion-html-${termCondition.svcToaId}`" v-if='termCondition.svcToaId ==="requiredForCreditInformation"'  v-html="requiredHtmlCntn4" />
                      <div  v-if='termCondition.svcToaId ==="requiredForMobileInstallment"'  v-html="requiredForMobileInstallment" />
                    </div>                    
                </li>
                  <li class='accordion type-01' v-for='termCondition in this.optTermConditionList' v-bind:key='termCondition.svcToaId'>
                    <div  :id="'accordion-required-' + termCondition.svcToaId" class='accordion-title'  role='heading'>
                      <div :id="'checkbox-container-' + termCondition.svcToaId" class='input-container'>
                        <input :id="'accordion-checkbox-' + termCondition.svcToaId"
                              type='checkbox'
                              :name='termCondition.svcToaId'
                              @click='clickedAgreement'
                              class='input-checkbox input-text'
                              v-model='termConditionCheckedStatus[termCondition.svcToaId]'>
                        <label class='input-label' :for="'accordion-checkbox-' + termCondition.svcToaId" >{{termCondition.svcToaNm}}</label>
                      </div>
                      <button class='fold-button'
                        @click='showHideAccordion(termCondition.svcToaId)'
                        title='자세히보기' tabindex='0'
                        :area-controls="'accordion-' + termCondition.svcToaId + '-detail'"
                        :id="termCondition.svcToaId + '-show'"
                        ></button>                      
                    </div>
                    <div :id="'accordion-' + termCondition.svcToaId + '-detail'" class='accordion-detail' tabindex='0' :aria-labelledby="termCondition.svcToaId + '-show'" role='region' >
                      <div  :id="'accordion-html-' + termCondition.svcToaId" v-if='termCondition.svcToaId ==="optionalMarketingOffer"'  v-html="optionalHtmlCntn1" />
                      <div  v-if='termCondition.svcToaId ==="optionalMarketingOfferAds"'  v-html="optionalMarketingOfferAds" />
                      <div  :id="'accordion-html-' + termCondition.svcToaId" v-if='termCondition.svcToaId ==="optionalMarketingOfferPersonal"'  v-html="optionalHtmlCntn2" />
                      <div  v-if='termCondition.svcToaId ==="optionalMarketingOfferPersonalTrst"'  v-html="optionalMarketingOfferPersonalTrst" />
                    </div>
                </li>
              </ul>  
            </dd>               
          </dl>          
        </div>
      </div>
      <div class='section'>
        <div class='section-header'>
          <h3>가입정보 자동입력동의</h3>
        </div>      
        <div class='section-body'>
          <dl class='field-group'>
            <dt class='field-label'>
              <label>가입정보 자동입력동의</label>
            </dt>       
            <dd class='field-control'>
              <div class='input-container'>
                <input id='agreement02-check_01'  type='checkbox' class='input-checkbox input-text' v-model="custAgreeYnChk" >                              
                <label for='agreement02-check_01' class='input-label'>사용자편의를 위해 LG유플러스 통신 서비스 가입이 되어있을 경우 가입정보 자동입력을 위한 개인정보 이용에 동의합니다. (LG유플러스 고객만 해당)</label>
              </div>              
            </dd>               
          </dl> 
        </div>
      </div>
    </div>
    <div class='registration-page'  v-if="this.isStep1">
      <div class='registration-page-container'>
        <div class='section'>
          <div class='section-header'>
            <h3>본인인증</h3>
          </div>
          <div class='section-body'>
            <ul class="notice-text-list">
              <li class='notice-text'>가입신청을 위해<span  v-if="(this.openmktCd==='14204')"> 아래의 방법 중 한가지로 </span> 본인인증을 하시기 바랍니다. (인증하기 버튼 탭 시 인증 진행)</li>         
              <li class='notice-text' v-if="(this.openmktCd==='14204')">가입자명의 스마트폰 보유고객은 휴대폰인증, 가입자명의 I-PIN 보유고객은 I-PIN 인증을 선택해주세요.</li>            
            </ul>           
            <dl class='field-group'>
              <dt class='field-label'>
                <label>인증하기</label>
              </dt>       
              <dd class='field-control'>    
                <div class="field-control-sub m-input-half">
                
                  <button type='button mw100 m-right' @click='cellphoneAuth' v-bind:disabled="changeDisabled" :class="{ disabled:changeDisabled }">휴대폰인증</button>
                   <!-- openmktCd :14204  자동차 패드일 경우만 아이핀인증 -->
                  <span   v-if="(this.openmktCd==='14204')" class='field-group-space'></span>
                  <button v-if="(this.openmktCd==='14204' && this.entrLoc == '')" type='button mw100 m-right'  @click='iPinAuth'  v-bind:disabled="changeDisabled" :class="{ disabled:changeDisabled }">I-PIN인증</button>
                  <!--
                  <span v-if="!($store.state.isMobile)" class='field-group-space'></span>
                  <button v-if="!($store.state.isMobile)" type='button mw100 m-right'  @click='iPinAuth'>I-PIN인증</button>
                  -->

                </div>         
              </dd>               
            </dl>        
            <div v-show="ifameShow" class='field-control-sub'>
           <!--  <iframe ref="iframeAuth" src="" style="height:950px; width:500px; align:center; border:0px;"></iframe> -->
              <p class='field-iframe' >
                <iframe ref="iframeAuth" src="" style="overflow-x:hidden; overflow:auto; width:100%; height:100%; align:center; border:0px;"></iframe>
              </p>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  <v-dialog/>
  </div>


</template>

<script>
import { callKmcAuthPopup, callIpinPopup, saveKmcAuthInfo } from '@/api/common'
import {metaServiceRepo} from '@/repository/metaServiceHardCodedDataRepo'
import {actionType} from '@/store'
import { getMobileCupsifItemList } from '@/api/openmarket'//privacy센터_항목목록조회 추가

export default {
  name: 'ConnectedCar',
  data() {
    return {
      phonePayStyleCd: '',
      phonePayStyle: '',
      trmMdlNm: '',
      itemSn: '',
      opmkEntrKdCd: 'new',
      isUsedPhone:false,
      isStep1:false,
      termConditionList: [],
      termConditionCheckedStatus: {},
      custAgreeYnChk: false,
      isttYn: 'Y',
      ifameShow: false,
      carType: '',
      imei: '',
      agentId:'',
      dashCtn:'',
      usimMdlNm:'',
      usimSn:'',
      payYn:'',
      openmktCd:'',// 추가 2022.05.10 장희정
      entrLoc: '',

      //reqTermConditionList: [], //필수항목
      //optTermConditionList: [], //선택항목

      requiredHtmlCntn1: '',
      requiredHtmlCntn2: '',
      requiredHtmlCntn3: '',
      requiredHtmlCntn4: '',
      requiredHtmlCntn5: '',
      //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
      requiredHtmlCntn6: '',
      requiredHtmlCntn7: '',
      requiredHtmlCntn8: '',
      //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
      optionalHtmlCntn1: '',
      optionalHtmlCntn2: '',

      agrList: [], //dataCapture save 사용
      cupsifItemList: [], //privacyCenter 연계구축 추가
      openMarketAgrInfo: [], //privacy 동의정보

      changeDisabled: false
      
    }
  },
  components: {},
  computed: {
      reqTermConditionList() {
        //console.log('termConditionList (필수):', JSON.stringify(this.termConditionList, null, 2));
        return this.termConditionList.filter(i => i.req)
      },
      optTermConditionList() {
        return this.termConditionList.filter(i => !i.req)
      },
      requiredForUPlusService() {  // LG유플러스 서비스 이용약관 동의 (필수)
        let fileName='agree1.html' 
        if(this.isConciergeDevice){ fileName='agree1_cdevice.html'}
        return require('html-loader!~/html/appl/'+fileName)
      },
      requiredForPersonalInformation() {  // 개인정보 수집 이용동의 (필수)
        let fileName='agree2.html'
      //  if(this.isNote7) fileName='agree2_SM_N930L.html'
        return  require('html-loader!~/html/appl/'+fileName)
      },
      requiredForPersonalLocInform_mobile() { //개인위치정보 수집·이용 및 위치정보사업/위치기반 서비스 이용약관 동의 (필수) - 개인정보수집과 개인위치정보수집 분리를 위한 추가
        return require('html-loader!~/html/appl/agree_personal_location_mobile.html')
      },      
      //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 개인정보.개인위치정보 수집.이용 동의 제거
      //  requiredForPersonalLocationInformation(){//이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가
      //   return require('html-loader!~/html/appl/agree_personal_location.html')
      // },
      //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정
      requiredForServiceProviding() {   // 서비스 제공을 위한 개인정보 제공 이전 동의 (필수)
        return  require('html-loader!~/html/appl/longdesc_agree7.html')
      },
      requiredForCreditInformation() {  // 신용정보 조회에 관한 동의 (필수)
        let fileName='agree11.html'
        if(this.isConciergeDevice) fileName='agree3_cdevice.html'
        return  require('html-loader!~/html/appl/'+fileName)
      },
      optionalMarketingOffer() {   // 고객 혜택 정보/광고 정보제공을 위한 동의(선택) =>24.05.02 고객 혜택정보 제공을 위한 정보 수집 ·이용 동의 
        return require('html-loader!~/html/appl/agree8.html')
      },
      optionalMarketingOfferAds() {   // 설문조사,재화 서비스홍보 및 권유를 위한 동의 (마케팅 활용동의)(선택)
        return require('html-loader!~/html/appl/agree9.html')
      },
      optionalMarketingOfferPersonal() {  // 위치기반 정보제공 및 광고전송 서비스 동의 (마케팅 활용동의)(선택) =>24.05.02 혜택정보 · 광고 수신 동의                                                                   
        return require('html-loader!~/html/appl/agree10.html')
      },
      optionalMarketingOfferPersonalTrst() {  //24.05.02 고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내
        return require('html-loader!~/html/appl/agree16.html')
      },    
      requiredForMobileInstallment() {
        return require('html-loader!~/html/appl/agree5.html')
      },
   /* IOS() {// ios 체크
      return navigator.userAgent.match(/iPhone|iPad|iPod/i) == null ? false : true;
    },
    isPopup(){// 크롬 버전 체크
      return  this.getChromeBrowserVersion() >80 ? true : false;
    }
    */
  },
  beforeCreate() {

  },
  created() {

    // Url 파라미터 값 저장
    let params = this.getUrlParams()
    let originParams = this.getUrlParams();

    
    if(params.imei == undefined) {
      if(params.entrLoc == undefined){ //닛산
        this.carType = "A"; 
      }
      else { //도요타 후석
        this.carType = "C"
        this.entrLoc = params.entrLoc
      }
    //도요타
    } else if((params.imei+"").length > 0) {
      this.carType = "B";

      for(var key in params) {
        
        if(key != "formId" && key != "agentId" && key != "openmktCd"){
          params[key] = window.atob(decodeURIComponent(params[key]));
        }
        
      }
    }

    // returnUrl 저장

    if (params.agentId && params.formId && params.openmktCd) {
      Promise.all([this.$store.dispatch('saveDealerInfo', params), this.$store.dispatch('saveConnectedCarInfo', params)]).then(() => {
        if(this.carType == "A") {
          this.$store.dispatch('setReturnUrl', decodeURIComponent(params.returnUrl)+"?itemSn="+params.itemSn+"&usimMdlNm="+params.usimMdlNm+"&usimSn="+params.usimSn+"&naviSn="+params.naviSn+"&uiccId="+params.uiccId+"&oldYn="+this.$store.state.connectedCar.common.payYn+"&termsYn=Y&registerYn=Y")
        } else if(this.carType == "B") {
          this.$store.dispatch('setReturnUrl', params.returnUrl+"?itemSn="+originParams.itemSn+"&usimMdlNm="+originParams.usimMdlNm+"&usimSn="+originParams.usimSn+"&uiccId="+originParams.uiccId+"&imei="+originParams.imei+"&ctn="+originParams.ctn+"&oldYn="+encodeURIComponent(window.btoa(this.$store.state.connectedCar.common.payYn))+"&termsYn="+encodeURIComponent(window.btoa("Y"))+"&registerYn="+encodeURIComponent(window.btoa("Y")))
          this.imei = params.imei;
          this.usimSn = params.usimSn;
          this.usimMdlNm = params.usimMdlNm;
          let ctnLengh = params.ctn.length;
          this.dashCtn = params.ctn.substring(0,ctnLengh-8)+'-'+params.ctn.substring(ctnLengh-8,ctnLengh-4)+'-'+params.ctn.substring(ctnLengh-4,ctnLengh);
          this.$store.state.connectedCar.common.imei = params.imei;
          this.$store.state.connectedCar.common.ctn = params.ctn;
        }
        
        
        this.itemSn = this.$store.state.connectedCar.common.itemSn
        this.opmkEntrKdCd = this.$store.state.connectedCar.dealerInfo.opmkEntrKdCd
        this.trmMdlNm = this.$store.state.connectedCar.common.trmMdlNm
        this.phonePayStyleCd =  this.$store.state.connectedCar.common.phonePayStyleCd
        this.phonePayStyle =  this.$store.state.connectedCar.common.phonePayStyle
        this.agentId = params.agentId;
        this.openmktCd= params.openmktCd;// 추가 2022.05.10 장희정
        this.payYn=this.$store.state.connectedCar.common.payYn
        if(this.$store.state.connectedCar.common.usimSn === null ){
          this.$store.state.connectedCar.common.usimSn = params.usimSn
        }  
        if("Y"=== this.payYn){
          this.isUsedPhone = true
        }else{
          this.isStep1 = true
        }
      }).catch(e => {
        this.$router.push({
          name: 'Error',
          params: {
            message: '등록된 정보가 없습니다.\n확인 후 다시 접속하시기 바랍니다.',
            type: 'error'
          }
        })
      })
    } else {
       this.$router.push({
          name: 'Error',
          params: {
            message: '유효 하지 않은 URL로 접근 하였습니다.',
            type: 'error'
          }
        })
    }
    
    // let params = this.getUrlParams()
    //     return new Promise(resolve => {
    //         connectedCarInfo(params.appfFomNo, params.dealCd, params.opmkNo, params.itemSn,
    //          params.naviSn, params.uiccId, params.usimMdlNm, params.usimSn).then(res => {                
    //             resolve(res);
    //         }).catch(err => {
    //           // let title = '온라인 가입신청 안내'
    //           // let message = err.data.data.message 
    //           // this.openAlert(title, message)
    //           // return false;

    //           let commonData = {
    //             payYn: 'N',
    //             appfFomNo: params.appfFomNo,
    //             dealCd: params.dealCd,
    //             opmkNo: params.opmkNo
    //           }
    //           this.$store.commit('SET_CONNECTED_CAR_COMMON', commonData)
    //           this.isStep1 = true  // 중고일 경우 step 1 
    //         })
    //     }).then(res => {
    //         this.itemSn = params.itemSn
    //         this.opmkEntrKdCd = res.data.opmkEntrKdCd
    //         this.trmMdlNm = res.data.trmMdlNm
    //         this.phonePayStyleCd = res.phonePayStyleCd
    //         // let commonData = {
    //         //   payYn: 'Y',
    //         //   appfFomNo: params.appfFomNo,
    //         //   dealCd: params.dealCd,
    //         //   opmkNo: params.opmkNo
    //         // }
    //         this.$store.commit('SET_CONNECTED_CAR_COMMON', res.data)    
    //         if(this.$store.state.connectedCar.common.usimSn === null ){
    //           this.$store.state.connectedCar.common.usimSn = params.usimSn
    //         }  
    //         this.isUsedPhone = true
    //     })
  },

  beforeMount() {
  },
  mounted() {
    //this.sysNotice()
    this.$store.state.processIndicator.step1 = true
    this.$store.state.processIndicator.step2 = false
    this.$store.state.processIndicator.step3 = false

    this.getTermConditionList()

    //privacy센터 html 항목내용
    
    //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21  
    // 고유식별 정보 수집.이용 동의  svcToaId = requiredForConciergeDeviceOnlyOneInformation  로 수정
    // this.requiredHtmlCntn1 = this.requiredForPersonalInformation // 개인정보 수집 이용동의 (필수) - A0004
    this.requiredHtmlCntn1 = this.requiredForConciergeDeviceOnlyOneInformation // 고유식별 정보 수집, 이용 동의 (필수) - A0004

    // 개인정보.개인위치정보 수집.이용 동의 제거  
    // this.requiredHtmlCntn2 = this.requiredForPersonalLocationInformation //이용약관 개인정보위치 수집동의(필수) - A0006
    //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21

    this.requiredHtmlCntn3 = this.requiredForServiceProviding // 서비스 제공을 위한 개인정보 제공 이전 동의 (필수) - A0035
    this.requiredHtmlCntn4 = this.requiredForCreditInformation // 신용정보 조회에 관한 동의 (필수) - A0036
    this.requiredHtmlCntn5 = this.requiredForPersonalLocInform_mobile // 개인위치정보 수집·이용 및 위치정보사업/위치기반 서비스 이용약관 동의 (필수) - A0182  << 화면에서만 노출  

    //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21  
    this.requiredHtmlCntn6 = this.requiredForPersonalInformation           // 개인정보 수집.이용 동의 추가 (필수)  - A0159
    this.requiredHtmlCntn7 = this.requiredForSensitiveInform_mobile        // 민감정보(생체인식정보) 수집.이용 동의 (필수)   - A0341
    this.requiredHtmlCntn8 = this.requiredForPersonalAbroadTransfer_mobile // 개인정보 국외이전동의 (필수) - A0340
    //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21  

    this.optionalHtmlCntn1 = this.optionalMarketingOffer // 고객 혜택 정보/광고 정보제공을 위한 동의(선택) - I0001
    this.optionalHtmlCntn2 = this.optionalMarketingOfferPersonal //혜택정보 · 광고 수신 동의(선택) - I0002
    
    this.setCupsifItem() //privacy센터 목록 추가

   // document.cookie="SameSite=None; Secure" //chorme 80 쿠키이슈 2020.08.24
  },
  methods: {

      /**
       * Function    : backToPreviousStep
       * Description : 이전 스텝으로 이동
       **/
      backToPreviousStep() {
        this.$router.go(-1)
      },

      /** 
       * Function    : getTermConditionList
       * Description : 이용약관 리스트 조회
       **/
      getTermConditionList() {
        const termConditionResponsePromise = metaServiceRepo.getTermConditionList()
        if (termConditionResponsePromise !== undefined) {
          termConditionResponsePromise
            .then((response) => {
              response.json()
                .then((jsonResponse) => {
                  this.termConditionList = jsonResponse.filter(item => {
                    if (this.isttYn === 'N') {
                      //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21  
                      // return (item.svcType === 'G' && item.svcToaId !== 'requiredForMobileInstallment'
                      //   -- 개인정보위치 수집동의(필수) - A0006  (requiredForPersonalLocationInformation)  제외에  추가
                      //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21  
                      return (item.svcType === 'G' && item.svcToaId !== 'requiredForMobileInstallment' && item.svcToaId !== 'requiredForPersonalLocationInformation')
                          || item.svcType === 'GD' || item.svcType === 'M'
                    } else {
                      //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21  
                      // return (item.svcType === 'G' && item.svcToaId !== 'requiredForMobileInstallment'
                      //   -- 개인정보위치 수집동의(필수) - A0006  (requiredForPersonalLocationInformation)  제외에  추가
                      //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21  
                      return (item.svcType === 'G' &&  item.svcToaId !== 'requiredForPersonalLocationInformation') 
                          || item.svcType === 'GD' || item.svcType === 'M'
                    }                    
                  })
//                  console.log("jsonResponse",JSON.stringify(this.termConditionList));
                  this.termConditionList.forEach(termAndCondition => {
                  this.termConditionCheckedStatus[termAndCondition.svcToaId] = false
                  })

                })
            })
        }
      },

      /** 
       * Function    : showHideAccordion
       * Description : 약관 Accordion Control
       **/
      showHideAccordion(id) {
        const panel = document.getElementById('accordion-' + id + '-detail')
        
        if (panel.style.maxHeight)
          panel.style.maxHeight = null,
          panel.style.height = null,
          panel.style.padding = '0 12px',
          panel.style.overflow = 'hidden',
          panel.style.visibility = 'hidden',
          panel.previousElementSibling.classList.toggle("active");
        else
          panel.style.maxHeight = '220px',
          panel.style.height = 'auto',
          panel.style.padding = '12px',
          panel.style.overflow = 'auto',
          panel.style.visibility = 'visible',
          panel.previousElementSibling.classList.toggle("active");
      }, 

      /** 
       * Function    : checkAll
       * Description : 약관 전체 선택
       **/
      checkAll(checkAllEvent) {
        this.termConditionList.forEach(termCondition => {
          const elementId = 'accordion-checkbox-' + termCondition.svcToaId

            const htmlElement = document.getElementById(elementId)
            if(htmlElement != null) {
              htmlElement.checked = checkAllEvent.target.checked

              const simulatedEvent = {
                target: {
                  name: termCondition.svcToaId,
                  checked: checkAllEvent.target.checked,
                }
              }

              this.clickedAgreement(simulatedEvent)
          }
        })
      },

      /** 
       * Function    : clickedAgreement
       * Description : 약관 동의 선택 event
       **/
      clickedAgreement(event) {
        let termAndConditionName = event.target.name
        this.termConditionCheckedStatus[termAndConditionName] = event.target.checked
        this.$store.dispatch(actionType.saveStep1TnC, this.termConditionCheckedStatus)
      },

      /** 
       * Function    : cellphoneAuth
       * Description : 휴대폰 인증 필수값 Validation 후 Kmc 호출
       **/
      cellphoneAuth() {
        
        if (this.validateInput()) {
          
          if(this.appfName === ""){
              this.$modal.show('dialog', {
                  title: '본인 인증',
                  text: '이름을 입력해주세요.',
                  buttons: [{
                      title: '확인',
                      class: 'primary-button',
                  }]
              })
              return;
          }
                
        //privacy센터와 연동할 선택동의 값
        this.agrList = [];
        this.termConditionCheckedStatus.optionalMarketingOffer = (this.termConditionCheckedStatus[this.optTermConditionList[0].svcToaId]) ? 'Y' : 'N'      
        this.termConditionCheckedStatus.optionalMarketingOfferPersonal = (this.termConditionCheckedStatus[this.optTermConditionList[1].svcToaId]) ? 'Y' : 'N'

        for(let i = 0; i < this.cupsifItemList.length; i++) {//privacy 동의정보

          let sCupsifItemId = this.cupsifItemList[i].cupsifItemId
          let sCupsifItemVerNo = this.cupsifItemList[i].cupsifItemVerNo
          let sCupsifItemNm = this.cupsifItemList[i].cupsifItemNm
          let sCupsifItemKdCd = this.cupsifItemList[i].cupsifItemKdCd
          let sCupsifItemAgrKdCd = this.cupsifItemList[i].cupsifItemAgrKdCd
          let sHposCupsifItemKdCd = this.cupsifItemList[i].hposCupsifItemKdCd
          let sCupsifYn = ''

          //[CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21 
          // A0159, A0182, A0340, A0341 추가,  A0006 (개인정보.개인위치정보 수집.이용 동의) 는 제외
          // if(sCupsifItemKdCd === 'A0004' || 
          //   sCupsifItemKdCd === 'A0006' ||
          //   sCupsifItemKdCd === 'A0035' || 
          //   sCupsifItemKdCd === 'A0036'
          //   ) {
          if(sCupsifItemKdCd === 'A0004' ||
            sCupsifItemKdCd === 'A0035' || 
            sCupsifItemKdCd === 'A0036' ||
            sCupsifItemKdCd === 'A0159' ||
            sCupsifItemKdCd === 'A0182' ||
            sCupsifItemKdCd === 'A0341' ||
            sCupsifItemKdCd === 'A0340'
            ) {

            sCupsifYn = 'Y'   //필수 동의 'Y'

          } else if(sCupsifItemKdCd === 'I0001') {

            sCupsifYn = this.termConditionCheckedStatus.optionalMarketingOffer //고객 혜택정보 제공을 위한 정보 수집 · 이용 동의

          } else if(sCupsifItemKdCd === 'I0002') {

            sCupsifYn = this.termConditionCheckedStatus.optionalMarketingOfferPersonal //혜택정보 · 광고 수신 동의

          }
          
          this.agrList.push( { cupsifItemId: sCupsifItemId, cupsifItemVerNo: sCupsifItemVerNo, cupsifItemNm: sCupsifItemNm, cupsifItemKdCd: sCupsifItemKdCd, cupsifItemAgrKdCd: sCupsifItemAgrKdCd, hposCupsifItemKdCd: sHposCupsifItemKdCd, cupsifYn: sCupsifYn } )
        }

        this.$store.state.step1.openMarketAgrInfo = this.agrList
        //console.log(JSON.stringify(this.$store.state.step1.openMarketAgrInfo));         

          if (this.carType == "B" ) {
            this.ifameShow = true;
            this.$refs.iframeAuth.setAttribute("src", "/auth-popup/kmc-auth-popup?tr_add=Y");
          }

          let params = {
            termConditionCheckedStatus: this.termConditionCheckedStatus,
            onetAutnMthdDivsCd: 'M'
          }
          callKmcAuthPopup(this.ifameShow).then(res => {

            let custInfo = JSON.parse(res)
            //let kmcDate = (custInfo.certNum+"").substring(0,4) + '-' + (custInfo.certNum+"").substring(4,6) + '-' + (custInfo.certNum+"").substring(6,8) + ' ' + (custInfo.certNum+"").substring(8,10) + ':' + (custInfo.certNum+"").substring(10,12) + ':' + (custInfo.certNum+"").substring(12,14)
            let mobileData = {}
            mobileData = {
              //onetMblAppfNo: res.data.appfNo,
              onetMblAppfNo: '-',
              //dealCd: res.data.sbgnDealCd,
              dealCd: this.agentId,
              regiDate: (custInfo.certNum + "").substring(0, 14),
              juminNo: custInfo.birthDay,
              custName: custInfo.name,
              //smsval: this.$store.state.connectedCar.common.smsval,
              smsval: '-',
              tradeid: custInfo.certNum,
              mobilid: custInfo.r_phoneCorp,
              no: custInfo.phoneNo,
              prdtnm: 'KMC',
              //tradeid: this.$store.state.connectedCar.common.tradeid
            }

            // 인증정보 저장
            saveKmcAuthInfo(mobileData).then(res => {
            })

            this.$store.commit('SET_CONNECTED_CAR_PERSON', custInfo)
            this.$router.push({
              name: 'ConnectedCarStep2',
              props: true,
              params: params
            })
          }).catch(error => {
            this.openAlert('온라인 가입신청 안내', '본인인증 도중 문제가 발생하였습니다.\n다시 시도해주시기 바랍니다.')
          })
        }
        
      },

      /** 
       * Function    : iPinAuth
       * Description : 아이핀 호출
       **/
      iPinAuth() {
        
        if (this.validateInput()) {

        //privacy센터와 연동할 선택동의 값
        this.agrList = [];
        this.termConditionCheckedStatus.optionalMarketingOffer = (this.termConditionCheckedStatus[this.optTermConditionList[0].svcToaId]) ? 'Y' : 'N'      
        this.termConditionCheckedStatus.optionalMarketingOfferPersonal = (this.termConditionCheckedStatus[this.optTermConditionList[1].svcToaId]) ? 'Y' : 'N'         
        
        for(let i = 0; i < this.cupsifItemList.length; i++) {//privacy 동의정보

          let sCupsifItemId = this.cupsifItemList[i].cupsifItemId
          let sCupsifItemVerNo = this.cupsifItemList[i].cupsifItemVerNo
          let sCupsifItemNm = this.cupsifItemList[i].cupsifItemNm
          let sCupsifItemKdCd = this.cupsifItemList[i].cupsifItemKdCd
          let sCupsifItemAgrKdCd = this.cupsifItemList[i].cupsifItemAgrKdCd
          let sHposCupsifItemKdCd = this.cupsifItemList[i].hposCupsifItemKdCd
          let sCupsifYn = ''

          //[CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21 
          // A0159, A0182, A0340, A0341 추가,  A0006 (개인정보.개인위치정보 수집.이용 동의) 는 제외
          // if(sCupsifItemKdCd === 'A0004' || 
          //   sCupsifItemKdCd === 'A0006' ||
          //   sCupsifItemKdCd === 'A0035' || 
          //   sCupsifItemKdCd === 'A0036') {
          if(sCupsifItemKdCd === 'A0004' || 
            sCupsifItemKdCd === 'A0006' ||
            sCupsifItemKdCd === 'A0035' || 
            sCupsifItemKdCd === 'A0036' ||
            sCupsifItemKdCd === 'A0159' ||
            sCupsifItemKdCd === 'A0182' ||
            sCupsifItemKdCd === 'A0341' ||
            sCupsifItemKdCd === 'A0340'
            ) {

            sCupsifYn = 'Y'   //필수 동의 'Y'

          } else if(sCupsifItemKdCd === 'I0001') {

            sCupsifYn = this.termConditionCheckedStatus.optionalMarketingOffer //고객 혜택정보 제공을 위한 정보 수집 · 이용 동의

          } else if(sCupsifItemKdCd === 'I0002') {

            sCupsifYn = this.termConditionCheckedStatus.optionalMarketingOfferPersonal //혜택정보 · 광고 수신 동의

          }
          
          this.agrList.push( { cupsifItemId: sCupsifItemId, cupsifItemVerNo: sCupsifItemVerNo, cupsifItemNm: sCupsifItemNm, cupsifItemKdCd: sCupsifItemKdCd, cupsifItemAgrKdCd: sCupsifItemAgrKdCd, hposCupsifItemKdCd: sHposCupsifItemKdCd, cupsifYn: sCupsifYn } )
        }
        
        this.$store.state.step1.openMarketAgrInfo = this.agrList
        //console.log(JSON.stringify(this.$store.state.step1.openMarketAgrInfo));

          if (this.carType == "B" ) {
            this.ifameShow = true;
            this.$refs.iframeAuth.setAttribute("src", "/auth-popup/ipin-auth-popup");
          } 

          let params = {
            termConditionCheckedStatus: this.termConditionCheckedStatus,
            onetAutnMthdDivsCd: 'I'
          }
          callIpinPopup(this.ifameShow).then(res => {
            let splitRes = res.split(',')
            let custInfo = {
              name: splitRes[0],
              phoneNo: '',
              birthDay: splitRes[1]
            }
            this.$store.commit('SET_CONNECTED_CAR_PERSON', custInfo)
            this.$router.push({
              name: 'ConnectedCarStep2',
              props: true,
              params: params
            })
          }).catch(error => {
            this.openAlert('온라인 가입신청 안내', '본인인증 도중 문제가 발생하였습니다.\n다시 시도해주시기 바랍니다.')
          })
        }
        
      },


    /**
       * Function    : validateInput
       * Description : 필수값 Validation
       **/
      validateInput() {
        let title = '온라인 가입신청 안내'
        let message = ''

        if(this.termConditionCheckedStatus.requiredForUPlusService == false){
             message = "LG유플러스 서비스 이용약관에 동의 하셔야 합니다."
            this.openAlert(title, message)
            return false;
        }

        //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
        // 고유식별 정보 수집.이용 동의  svcToaId = requiredForConciergeDeviceOnlyOneInformation  로 수정
        // if(this.termConditionCheckedStatus.requiredForPersonalInformation == false){
        if(this.termConditionCheckedStatus.requiredForConciergeDeviceOnlyOneInformation == false){
        //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21

            //message = "개인정보 수집 이용 동의에 동의하셔야 합니다."
            message = "고유식별 정보 수집 이용 동의에 동의하셔야 합니다." 
            this.openAlert(title, message)
            return false;
        }
        /* ST 이용약관 개인정보위치 수집동의 분리 2020.06.22 장희정 추가*/
        /* -- 2026.05.21  A0006  미사용   */
        if(this.termConditionCheckedStatus.requiredForPersonalLocationInformation == false){ //개인정보 수집·이용동의로 수정
             //message = "개인위치정보 수집,이용 동의에 동의하셔야 합니다."
             //message = "개인정보, 개인위치정보 수집,이용 동의에 동의하셔야 합니다."
            message = "개인정보 수집,이용 동의에 동의하셔야 합니다."
            this.openAlert(title, message)
            return false;
        }
         /* ET 이용약관 개인정보위치 수집동의 분리 2020.06.22 장희정 추가*/

        //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
        // 개인정보 수집.이용 동의 
        if(this.termConditionCheckedStatus.requiredForPersonalInformation == false){ //개인정보 수집.이용 동의
            message = "개인정보 수집.이용 동의에 동의하셔야 합니다."
            this.openAlert(title, message)
            return false;
        }
        //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21


        if(this.termConditionCheckedStatus.requiredForPersonalLocInform_mobile == false){ //개인정보수집과 개인위치정보수집 분리를 위한 추가

            // 메시지 문구 변경 : [CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
            // message = "개인위치정보 수집·이용 및 위치정보사업/위치기반 서비스 이용약관 동의에 동의하셔야 합니다."
            message = "개인위치정보 수집.이용 동의에 동의하셔야 합니다."
            this.openAlert(title, message)
            return false;
        }

        //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
        // 이용약관 민감정보(생체인식정보) 수집.이용 동의
        if(this.termConditionCheckedStatus.requiredForSensitiveInform_mobile == false){ //민감정보(생체인식정보) 수집.이용 동의
            message = "민감정보(생체인식정보) 수집.이용 동의에 동의하셔야 합니다."
            this.openAlert(title, message)
            return false;
        }
        //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21

        if(this.termConditionCheckedStatus.requiredForServiceProviding == false){
             //message = "서비스 제공을 위한 개인정보 제공 이전 동의에 동의하셔야 합니다."
            message = "개인정보 제3자제공 동의에 동의하셔야 합니다." 
            this.openAlert(title, message)
            return false;
        }

        //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
        // 개인정보 국외 이전 동의
        if(this.termConditionCheckedStatus.requiredForPersonalAbroadTransfer_mobile == false){ //개인정보 국외 이전 동의
            message = "개인정보 국외 이전 동의에 동의하셔야 합니다."
            this.openAlert(title, message)
            return false;
        }
        //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21

        
        if(this.termConditionCheckedStatus.requiredForCreditInformation == false){
             //message = "신용정보 조회에 관한 동의에 동의하셔야 합니다."
            message = "개인신용정보 조회 동의에 동의하셔야 합니다." 
            this.openAlert(title, message)
            return false;
        }
         /* ST 이용약관 개인정보위치 수집동의 분리 테스트 로 필수 체크 추가 2020.06.22 장희정 추가*/
        if(this.termConditionCheckedStatus.requiredForMobileInstallment == false){
             message = "휴대폰 할부계약 약정조항에 동의하셔야 합니다."
            this.openAlert(title, message)
            return false;
        }
         /* ET 이용약관 개인정보위치 수집동의 분리 테스트 로 필수 체크 추가  2020.06.22 장희정 추가*/

        //privacy센터 선택동의 중 종속관계 체크 요청
        if(this.termConditionCheckedStatus.optionalMarketingOffer == false && this.termConditionCheckedStatus.optionalMarketingOfferPersonal == true) {
          this.openAlert('온라인 가입신청 안내', '고객 혜택정보 제공을 위한 정보 수집 이용항목에 미동의하신 경우 혜택정보 광고 수신항목에 동의하실 수 없습니다.')
          return false
        }             

      if(this.custAgreeYnChk == false){
             message = "가입정보 자동 입력 동의에 동의하셔야 합니다."
            this.openAlert(title, message)
            return false;
        }  
        return true;
      },
    
    /** 
     * Function    : getUrlParams
     * Description : Url 파라미터 값 지역변수로 설정
     **/
    getUrlParams() {
      var params = {};
      window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) { params[key] = value; });
      return params;
    },

   /** 
     * Function    : setCupsifItem
     * Description : privacyCenter 항목 셋팅
     **/
    setCupsifItem(){
      getMobileCupsifItemList()
        .then(res => {
          let itemList = res.data.dsOutput
          this.cupsifItemList = res.data.dsOutput
          
          for(let i = 0; i < itemList.length; i++) {
            if(itemList[i].cupsifItemAgrKdCd === 'M') { //필수 약관 항목
              for(let j = 0; j < this.reqTermConditionList.length; j++) {

                //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
                // 고유식별 정보 수집.이용 동의  svcToaId = requiredForConciergeDeviceOnlyOneInformation  로 수정
                //  if(itemList[i].cupsifItemKdCd === 'A0004' && this.reqTermConditionList[j].svcToaId === 'requiredForPersonalInformation') { //고유식별 정보 수집.이용 동의
                //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
                if(itemList[i].cupsifItemKdCd === 'A0004' && this.reqTermConditionList[j].svcToaId === 'requiredForConciergeDeviceOnlyOneInformation') { //고유식별 정보 수집.이용 동의

                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (필수)'
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'                                
                  this.requiredHtmlCntn1  = this.applyHtml(itemList[i].cupsifItemCntn)
                  
                }

                //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정  - 2026.05.21
                // 개인정보.개인위치정보 수집.이용 동의 (A0006:requiredForPersonalLocationInformation) 제거
                // else if(itemList[i].cupsifItemKdCd === 'A0006' && this.reqTermConditionList[j].svcToaId === 'requiredForPersonalLocationInformation'){ //개인정보.개인위치정보 수집.이용 동의

                //   this.reqTermConditionList[j].req = true
                //   //this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (필수)'
                //   this.reqTermConditionList[j].svcToaNm = '개인정보 수집·이용동의 (필수)'
                //   this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                //   this.requiredHtmlCntn2  = this.applyHtml(itemList[i].cupsifItemCntn)

                // } 
                //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정  - 2026.05.21
                else if(itemList[i].cupsifItemKdCd === 'A0035' && this.reqTermConditionList[j].svcToaId === 'requiredForServiceProviding'){ //개인정보 제3자제공 동의

                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (필수)'
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  this.requiredHtmlCntn3  = this.applyHtml(itemList[i].cupsifItemCntn)
                  
                } else if(itemList[i].cupsifItemKdCd === 'A0036' && this.reqTermConditionList[j].svcToaId === 'requiredForCreditInformation'){ //개인신용정보 조회 동의

                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (필수)'
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  this.requiredHtmlCntn4  = this.applyHtml(itemList[i].cupsifItemCntn)
                  
                }
                //[ST][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
                else if(itemList[i].cupsifItemKdCd === 'A0159' && this.reqTermConditionList[j].svcToaId === 'requiredForPersonalInformation'){ //개인정보 수집.이용 동의
                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (필수)'
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  this.requiredHtmlCntn6  = this.applyHtml(itemList[i].cupsifItemCntn)
                }
                else if(itemList[i].cupsifItemKdCd === 'A0182' && this.reqTermConditionList[j].svcToaId === 'requiredForPersonalLocInform_mobile'){ //개인위치정보 수집.이용 동의
                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (필수)'
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  this.requiredHtmlCntn5  = this.applyHtml(itemList[i].cupsifItemCntn)
                }
                else if(itemList[i].cupsifItemKdCd === 'A0341' && this.reqTermConditionList[j].svcToaId === 'requiredForSensitiveInform_mobile'){ //민감정보(생체인식정보) 수집.이용 동의
                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (필수)'
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  this.requiredHtmlCntn7  = this.applyHtml(itemList[i].cupsifItemCntn)
                }
                else if(itemList[i].cupsifItemKdCd === 'A0340' && this.reqTermConditionList[j].svcToaId === 'requiredForPersonalAbroadTransfer_mobile'){ //개인정보 국외 이전 동의
                  this.reqTermConditionList[j].req = true
                  this.reqTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (필수)'
                  this.reqTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm + ' - 내용'
                  this.requiredHtmlCntn8  = this.applyHtml(itemList[i].cupsifItemCntn)
                }
                //[ED][CSR ID:RITM2727086] 프라이버시 센터 약관 추가/분리에 따른 오픈마켓 수정 - 2026.05.21
              }
            }else { //선택 약관 항목
              for(let j = 0; j < this.optTermConditionList.length; j++) {
                
                if(itemList[i].cupsifItemKdCd === 'I0001' && this.optTermConditionList[j].svcToaId === 'optionalMarketingOffer') { //고객 혜택정보 제공을 위한 정보 수집 · 이용 동의
                  
                  this.optTermConditionList[j].req = false
                  this.optTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (선택)'
                  this.optTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm
                  this.optionalHtmlCntn1  = this.applyHtml(itemList[i].cupsifItemCntn)
                  
                } else if(itemList[i].cupsifItemKdCd === 'I0002' && this.optTermConditionList[j].svcToaId === 'optionalMarketingOfferPersonal'){  //혜택정보 · 광고 수신 동의

                  this.optTermConditionList[j].req = false
                  this.optTermConditionList[j].svcToaNm = itemList[i].cupsifItemNm + ' (선택)'
                  this.optTermConditionList[j].svcToaCntn = itemList[i].cupsifItemNm
                  this.optionalHtmlCntn2  = this.applyHtml(itemList[i].cupsifItemCntn)
                  
                }
              }
            }
          }
        })
        .catch(e => {
          this.openAlert('동의항목 설정 오류')
        })
    },    

    /** 
     * Function    : goToConnectedCarStep1
     * Description : 커넥티드카 step1으로 이동 (중고일 경우)
     **/
    goToConnectedCarStep1() {
      this.isStep1 = true  // 중고일 경우 step 1 
      this.isUsedPhone = false
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message) {
        this.$modal.show('dialog', {
          title: title,
          text: message,
          buttons: [{
            title: '확인',
            class: 'primary-button',
          }]
        })
      },

      /**
       * Function    : notice
       * Description : 시스템공지
       **/
      sysNotice() {
        this.changeDisabled = true
        let  title="시스템작업안내"
        let  message = "보다 안정적인 서비스 제공을 위해 아래와 같이 시스템 작업이 진행됩니다.\n - 작업 일시: 2025년 4월 23일(수) 22:00 ~ 23:00\n - 영향 범위: 작업 시간 동안 서비스 이용이 제한됩니다.\n서비스 이용에 불편을 드려 죄송합니다."
        this.openAlert(title, message);
      },

    /*  getChromeBrowserVersion() {
            var version = null;
            let retrunvalue=0;
            var userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.indexOf('chrome') >= 0) {
                var matches = userAgent.match(/chrome\/([0-9]+\.[0-9]+\.[0-9]+\.[0-9]+)/);
                if (matches) {
                    version = matches[1];
                    let versionarr= version.split('.')
                    retrunvalue=parseInt(versionarr[0])
                }
            }
            return retrunvalue;
        }
        */
      
    applyHtml(html) {
      const textarea = document.createElement('textarea')
      textarea.innerHTML = html
      return textarea.value
    },
  
  }
}
</script>

<style scoped>
</style>
